<template>
  <div class="serve-header-warp">
    <div class="serve-header-warp-content-small" v-if="size === 'small'">
      <span class="more-btn" @click="doClick">
        查看更多
        <i class="btn-icon"></i>
      </span>
      <div class="tabs-warp">
        <span class="tabs-item" :class="activeId == item.id ? 'is-active' : ''" v-for="item in tabList" :key="item.id" @click="handleClick(item)">{{item.label}}</span>
      </div>
    </div>
    <div class="serve-header-warp-content" v-else>
      <div class="tabs-warp" >
        <span class="tabs-item" :class="activeId == item.id ? 'is-active' : ''" v-for="item in tabList" :key="item.id" @click="handleClick(item)">{{item.label}}</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "big"
    },
    value: [String, Number]
  },
  watch: {
    value: {
      handler: function(val) {
        this.activeId = val
      },
      immediate: true
    }
  },
  data() {
    return {
      activeId: '',
    }
  },
  methods: {
    handleClick(item) {
      console.log(item);
      this.activeId = item.id
      this.$emit('input', item.id)
      this.$emit('click', item.id)
    },
    btnClick() {
      this.$emit('btn-click')
    },
    doClick() {
      this.$emit('do-click')
    }
  }
}
</script>

<style lang='less' scoped>
  .serve-header-warp {
    width: 100%;
    .serve-header-warp-content {
      width: 100%;
      height: 55px;
      text-align: center;
      border-bottom: 1px solid #E8E8E8;
      .tabs-warp {
        height: 55px;
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 26px;
        .tabs-item {
          font-weight: 600;
          color: #808080;
          margin-right: 50px;
          position: relative;
          cursor: pointer;
        }
        .tabs-item:last-child {
          margin-right: 0;
        }
        .is-active::before {
          content: '';
          position: absolute;
          width: 29px;
          height: 3px;
          background: #0E7328;
          border-radius: 2px;
          bottom: 0;
          left: calc(50% - 25px);
        }

        .is-active {
          width: 104px;
          font-weight: 600;
          color: #333333;
          text-align: left;
          font-style: normal;
        }
      }


    }
    .serve-header-warp-content-small {
      width: 100%;
      height: 45px;
      text-align: center;
      border-bottom: 1px solid #E8E8E8;
      position: relative;
      .tabs-warp {
        height: 45px;
        width: 100%;
        display: flex;
        justify-content: left;
        font-size: 20px;
        .tabs-item {
          font-weight: 600;
          color: #808080;
          margin-right: 50px;
          position: relative;
          cursor: pointer;
        }
        .tabs-item:last-child {
          margin-right: 0;
        }
        .is-active::before {
          content: '';
          position: absolute;
          width: 29px;
          height: 3px;
          background: #2557B2;
          border-radius: 2px;
          bottom: 0;
          left: 0
        }

        .is-active {
          font-weight: 600;
          color: #333333;
          text-align: left;
          font-style: normal;
        }
      }
    }
    .serve-layout-btn {
      width: 100%;
      text-align: center;
      .simulation-btn {
        display: inline-block;
        cursor: pointer;
        width: 90px;
        height: 30px;
        line-height: 30px;
        border-radius: 2px;
        border: 1px solid #3585FF;
        color: #3585FF;
        font-size: 14px;
        // font-weight: 600;
      }
    }
  }

  .more-btn {
  width: 90px;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #0E7328;
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  font-size: 14px;
  color: #0E7328;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-icon {
    width: 7px;
    height: 7px;
    display: inline-block;
    background: url("~@/assets/img/more-small.png") center center no-repeat;
    background-size: 100% 100%;
    margin-left: 3px;
  }
}
</style>